import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragNDropIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7,
	height: 23,
	viewBox: "0 0 7 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1",
		"data-name": "Group 1",
		transform: "translate(-1305 -231)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3",
				"data-name": "Rectangle 3",
				width: 3,
				height: 3,
				transform: "translate(1305 231)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_10",
				"data-name": "Rectangle 10",
				width: 3,
				height: 3,
				transform: "translate(1305 239)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_14",
				"data-name": "Rectangle 14",
				width: 3,
				height: 3,
				transform: "translate(1305 247)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_6",
				"data-name": "Rectangle 6",
				width: 3,
				height: 3,
				transform: "translate(1305 235)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_8",
				"data-name": "Rectangle 8",
				width: 3,
				height: 3,
				transform: "translate(1305 243)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_12",
				"data-name": "Rectangle 12",
				width: 3,
				height: 3,
				transform: "translate(1305 251)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_4",
				"data-name": "Rectangle 4",
				width: 3,
				height: 3,
				transform: "translate(1309 231)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_9",
				"data-name": "Rectangle 9",
				width: 3,
				height: 3,
				transform: "translate(1309 239)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13",
				"data-name": "Rectangle 13",
				width: 3,
				height: 3,
				transform: "translate(1309 247)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_5",
				"data-name": "Rectangle 5",
				width: 3,
				height: 3,
				transform: "translate(1309 235)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_7",
				"data-name": "Rectangle 7",
				width: 3,
				height: 3,
				transform: "translate(1309 243)",
				fill: "#BDBDBD"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_11",
				"data-name": "Rectangle 11",
				width: 3,
				height: 3,
				transform: "translate(1309 251)",
				fill: "#BDBDBD"
			})
		]
	})
});
export default SvgDragNDropIcon;
